document.querySelectorAll('.card-size-products .card-size-products--size').forEach((link) => {
    link.addEventListener('click', (event) => {
        event.preventDefault();
        event.currentTarget.closest('.column').querySelectorAll('.product-card-size_products').forEach((card) => {
            card.classList.remove('active');
        });
        document.querySelector('#card-product-loop-' + event.currentTarget.getAttribute('data-product-loop')).classList.add('active');
        document.querySelector('#card-product-loop-' + event.currentTarget.getAttribute('data-product-loop') + ' .product-secondary-image').classList.add('hover');
    });
    link.addEventListener('mouseover', (event) => {
        event.currentTarget.closest('.column').querySelectorAll('.product-secondary-image').forEach((img) => {
            img.classList.add('hover');
        });
    });
});

document.querySelectorAll('.collapsible-text').forEach((collapsibleText) => {
    collapsibleText.querySelectorAll('.collapsible-text__toggle').forEach((toggle) => {
        toggle.addEventListener('click', (event) => {
            event.preventDefault();
            collapsibleText.classList.toggle('active');
        });
    });
});